import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { modalActions } from '../../redux/root-action';
import { modals } from '../../utils/constants';

const StyledContainer = styled.div`
  height: 100vh;
  overflow: scroll;
`;

class LearnMoreModal extends Component<any> {
  props: any;
  state: any;
  constructor(props: any) {
    super(props);
    this.state = { content: undefined };
  }

  async componentDidMount() {
    const response = await fetch('/content/workplace/en/participant/ri/learn-more.html');
    let data = await response.text();
    data = data.replace(/\s\s+/g, ' ');
    this.setState({ content: data });
    const xf = document.getElementsByClassName('experiencefragment');
    while (xf.length > 0) {
      xf[0].parentNode?.removeChild(xf[0]);
    }
  }

  handleCloseIconClick = () => {
    const { hideModal } = this.props;
    hideModal(modals.RIX_ASSUMPTIONS);
  };

  render(): JSX.Element {
    const { content } = this.state;
    return <StyledContainer dangerouslySetInnerHTML={{ __html: content }} />;
  }
}

export default connect(null, {
  hideModal: modalActions.hideModal,
})(LearnMoreModal);
